import { List, Map } from 'immutable';

const defaultState = Map({
  tabCount: 0,
  currentTab: 0,
  tabStatus: List(),
});

export default defaultState;
